function removeEmptyFields(obj: any): any {
  if (!obj || typeof obj !== "object") return obj;

  const cleaned = Object.entries(obj).reduce((acc: any, [key, value]) => {
    // Remove null, undefined, empty string, zero
    if (
      value === null ||
      value === undefined ||
      value === "" ||
      value === 0
    ) {
      return acc;
    }

    // Remove empty array
    if (Array.isArray(value)) {
      if (value.length === 0) return acc;

      const cleanedArray = value
        .map((item) =>
          typeof item === "object" ? removeEmptyFields(item) : item
        )
        .filter(
          (item) =>
            item !== null &&
            item !== undefined &&
            item !== "" &&
            item !== 0 &&
            !(typeof item === "object" && Object.keys(item).length === 0)
        );

      if (cleanedArray.length > 0) {
        acc[key] = cleanedArray;
      }

      return acc;
    }

    // Handle nested objects
    if (typeof value === "object") {
      const nested = removeEmptyFields(value);

      if (nested && Object.keys(nested).length > 0) {
        acc[key] = nested;
      }

      return acc;
    }

    acc[key] = value;
    return acc;
  }, {});

  return Object.keys(cleaned).length > 0 ? cleaned : undefined;
}
// export function MapInfluencerForAIFrontend(profile: any) {

//   const detail = profile.profile_detail?.[0] || {};
//   const profileData = profile.profile_data?.[0] || {};
//   const location = profile.location_category_language?.[0] || {};
//   const ageGender = profile.agegender_detail?.[0] || {};

//   const mapped = {
//     insta_name: detail.insta_name,
//     instagram_username: detail.username,
//     category_1: detail.category,
//     language: location.language ? location.language.split(",") : [],

//     followers: profileData.followers,
//     follows: profileData.follows,
//     media_count: profileData.media_count,
//     platform_type: detail.platform_type,
//     avg_plays:profileData.avg_plays,
//     avg_likes: profileData.public_avg_likes,
//     avg_comments: profileData.public_avg_comments,    
//     age: ageGender.age,
//     gender: ageGender.gender,

//     er: detail.er,
//     biography: detail.biography,

//     influencer_location:
//       `${location.city || ""}, ${location.state || ""}, ${location.country || ""}`.trim(),

//     total_likes_last_90_days: profileData.total_likes,
//     total_comments_last_90_days: detail.total_comments,
//     avg_likes_last_90_days: profileData.public_avg_likes,
//     avg_comments_last_90_days: profileData.public_avg_comments,
//     est_reach: profileData.average_reach,
//     total_impressions: profileData.total_impressions,

//     audience_age_gender: (profile.age_gender || []).reduce((acc: any, a: any) => {
//   if (!a.age_gender_range || !a.value) return acc;

//   // Example: "M.18-24"
//   const [genderCode, ageRange] = a.age_gender_range.split(".");

//   if (!ageRange) return acc;

//   if (!acc[ageRange]) {
//     acc[ageRange] = { male: 0, female: 0, unknown: 0 };
//   }

//   if (genderCode === "M") {
//     acc[ageRange].male += a.value;
//   } else if (genderCode === "F") {
//     acc[ageRange].female += a.value;
//   } else if (genderCode === "U") {
//     acc[ageRange].unknown += a.value;
//   }

//   return acc;
// }, {}),
//     top_cities: (profile.city_indian || [])
//     .slice(0, 5)
//     .map((c: any) => {
//         const fullCity = c.name || "";   // ✅ FIXED KEY

//         const [city, state] = fullCity.split(",");

//         return {
//         city: city?.trim(),
//         state: state?.trim(),
//         percentage: c.percentage,
//         };
//     })
//     .filter((c: any) => c.city),

//     top_countries: (profile.city_country || []).reduce((acc: any, c: any) => {
//       if (c.percentage > 0) {
//         const name = c.country_name || c.country;
//         if (name) acc[name] = c.percentage;
//       }
//       return acc;
//     }, {}),
//     audience_health: profile.audience_health?.[0]
//     ? removeEmptyFields({
//         real_people: profile.audience_health[0].real_people,
//         suspicious_accounts: profile.audience_health[0].suspicious_accounts,
//         likely_fake_followers: profile.audience_health[0].likely_fake_followers,
//         bots: profile.audience_health[0].bots,
//       })
//     : undefined,
//   };

//   return removeEmptyFields(mapped);
// }

export function MapInfluencerForAIFrontend(profile: any) {
  const detail = profile.profile_detail?.[0] ?? {};
  const profileData = profile.profile_data?.[0] ?? {};
  const location = profile.location_category_language?.[0] ?? {};
  const ageGender = profile.agegender_detail?.[0] ?? {};

  const mapped = {
    // Basic Info
    insta_name: detail.insta_name ?? profile.insta_name,
    instagram_username: detail.username ?? profile.username,
    category_1: detail.category ?? profile.category,
    biography: detail.biography ?? profile.biography,
    platform_type: detail.platform_type,
    er_last_90_days: detail.er ?? profile.er,
    followers_last_90_days: detail.followers ?? profile.followers,
    media_count_last_90_days: detail.media_count ?? profile.media_count,

    // Audience Basics
    age: ageGender.age,
    gender: ageGender.gender,
    language: location.language
      ? location.language.split(",")
      : [],

    influencer_location: [
      location.city,
      location.state,
      location.country,
    ]
      .filter(Boolean)
      .join(", "),

    // Followers & Profile Stats
    follows: profileData.follows ?? profile.follows,
    
    post_frequency: profile.post_frequency,

    avg_views_last_90_days: profileData.avg_plays ?? profile.avg_plays,

    total_likes_last_90_days:
      profileData.total_likes ?? profile.total_likes,

    total_comments_last_90_days:
      detail.total_comments ?? profile.total_comments,

    total_saved_last_90_days: profile.total_saved,

    avg_likes_last_90_days:
      profileData.public_avg_likes ??
      profile.public_avg_likes,

    avg_comments_last_90_days:
      profileData.public_avg_comments ??
      profile.public_avg_comments,

    est_reach_last_90_days:
      profileData.average_reach ?? profileData.manually_generated_reach,

    total_reach_last_90_days: profile.total_reach,

    total_impressions_last_90_days:
      profileData.total_impressions ??
      profile.total_impressions,

    // Profile Actions
    total_profile_views_last_90_days: profile.total_profile_views,
    total_website_clicks_last_90_days: profile.total_website_clicks,
    total_text_message_clicks_last_90_days:
      profile.total_text_message_clicks,
    audience_age_gender: (profile.age_gender ?? []).reduce(
  (acc: any, a: any) => {
    if (!a.age_gender_range || a.value == null) return acc;

    const [genderCode, ageRange] =
      a.age_gender_range.split(".");

    if (!ageRange) return acc;

    if (!acc[ageRange]) {
      acc[ageRange] = {
        male: 0,
        female: 0,
        unknown: 0,
      };
    }

    if (genderCode === "M") {
      acc[ageRange].male += a.value;
    } else if (genderCode === "F") {
      acc[ageRange].female += a.value;
    } else if (genderCode === "U") {
      acc[ageRange].unknown += a.value;
    }

    return acc;
  },
  {}
),
    // Reels Metrics
    reels: {
      total_plays_last_90_days: profile.reels_total_plays,
      total_likes_last_90_days: profile.reels_total_likes,
      total_comments_last_90_days: profile.reels_total_comments,
      total_saved_last_90_days: profile.reels_total_saved,
      total_reach_last_90_days: profile.reels_total_reach,
      total_replays_last_90_days:
        profile.reels_total_clips_replays_count,
      total_aggregated_plays_last_90_days:
        profile.reels_total_ig_reels_aggregated_all_plays_count,
      avg_watch_time_last_90_days:
        profile.reels_total_ig_reels_avg_watch_time,
      total_watch_time_last_90_days:
        profile.reels_total_ig_reels_video_view_total_time,
      reels_er_without_plays_last_90_days:
        profile.reels_er_without_plays,
      reels_er_with_plays_last_90_days:
        profile.reels_er_with_plays,
      total_reels_count_last_90_days:
        profile.total_reels_count_availaible,
    },

    // Image Metrics
    image_posts: {
      total_likes_last_90_days: profile.image_total_likes,
      total_comments_last_90_days: profile.image_total_comments,
      total_saved_last_90_days: profile.image_total_saved,
      total_reach_last_90_days: profile.image_total_reach,
      total_impressions_last_90_days:
        profile.image_total_impressions,
      total_count_last_90_days: profile.total_image_count,
      er_last_90_days: profile.image_er,
      est_reach_last_90_days: profile.image_est_reach,
      avg_impressions_last_90_days:
        profile.image_avg_impressions,
      avg_saves_last_90_days: profile.image_avg_saves,
    },

    // Carousel Metrics
    carousel_posts: {
      total_likes_last_90_days: profile.carousel_total_likes,
      total_comments_last_90_days:
        profile.carousel_total_comments,
      total_saved_last_90_days: profile.carousel_total_saved,
      total_reach_last_90_days: profile.carousel_total_reach,
      total_impressions_last_90_days:
        profile.carousel_total_impressions,
      total_count_last_90_days: profile.total_carousel_count,
      er_last_90_days: profile.carousel_er,
      est_reach_last_90_days: profile.carousel_est_reach,
      avg_impressions_last_90_days:
        profile.carousel_avg_impressions,
      avg_saves_last_90_days: profile.carousel_avg_saves,
    },

    // Reach Comparison
    reach_comparison: {
      reels_vs_avg_last_90_days:
        profile.reels_posts_est_reach_comparison,
      image_vs_avg_last_90_days:
        profile.image_posts_est_reach_comparison,
      carousel_vs_avg_last_90_days:
        profile.carousel_posts_est_reach_comparison,
    },

    // Generated Reach
    generated_reach: {
      system_generated_last_90_days: profile.generated_reach,
      estimated_generated_last_90_days:
        profile.est_generated_reach,
      manual_generated_last_90_days:
        profile.manually_generated_reach,
    },

    // Audience Totals
    audience_totals: {
      male: profile.total_male_count,
      female: profile.total_female_count,
      unknown: profile.total_unknown_count,
      adult_count: profile.total_adult_count,
      adult_percentage:
        profile.total_adult_percentage,
    },

    // Audience Health
    audience_health: profile.audience_health?.[0]
      ? removeEmptyFields({
          real_people:
            profile.audience_health[0].real_people,
          suspicious_accounts:
            profile.audience_health[0]
              .suspicious_accounts,
          likely_fake_followers:
            profile.audience_health[0]
              .likely_fake_followers,
          bots: profile.audience_health[0].bots,
        })
      : undefined,
    top_countries: (profile.city_country ?? [])
  .filter((c: any) => c?.percentage > 0)
  .slice(0, 5)
  .map((c: any) => ({
    name: c.name,
    code: c.code,
    followers: c.followers,
    percentage: c.percentage,
  })),

// Top Indian Cities
top_indian_cities: (profile.city_indian ?? [])
  .filter((c: any) => c?.percentage > 0)
  .slice(0, 5)
  .map((c: any) => {
    const [city, state] = (c.name ?? "").split(",");

    return {
      city: city?.trim(),
      state: state?.trim(),
      followers: c.followers,
      percentage: c.percentage,
    };
  }),

// Top International Cities
top_international_cities: (profile.city_international ?? [])
  .filter((c: any) => c?.percentage > 0)
  .slice(0, 5)
  .map((c: any) => {
    const [city, region] = (c.name ?? "").split(",");

    return {
      city: city?.trim(),
      region: region?.trim(),
      followers: c.followers,
      percentage: c.percentage,
    };
  }),
  };

  return removeEmptyFields(mapped);
}
